/* The Folding Forest page: scroll-open hero (pinned stage), unwrap steps, the tag and gift note, night light, phone bar. No libraries; only this section's elements. */
(function () {
  'use strict';
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var PAGE = '<svg viewBox="100 0 100 300" preserveAspectRatio="none" aria-hidden="true" focusable="false"><use href="#spcfHalfG"></use></svg>';

  function slices(fan, n) {
    var tpl = document.createElement('div');
    tpl.className = 'spc-forest-sl';
    tpl.innerHTML = PAGE;
    var f = document.createDocumentFragment(), out = [];
    for (var i = 0; i < n; i++) { var s = tpl.cloneNode(true); f.appendChild(s); out.push(s); }
    fan.appendChild(f);
    return out;
  }
  function flakes(box, n, fall) {
    var f = document.createDocumentFragment();
    for (var i = 0; i < n; i++) {
      var s = document.createElement('span');
      s.className = 'spc-forest-fl';
      s.style.left = ((i * 37) % 100 + 0.5) + '%';
      s.style.setProperty('--fd', (9 + ((i * 53) % 17) * 0.45).toFixed(1) + 's');
      s.style.setProperty('--fl', '-' + (((i * 29) % 11) * 1.1 + i * 0.13).toFixed(1) + 's');
      s.style.setProperty('--fs', (3 + (i % 5) * 0.7).toFixed(1) + 's');
      s.style.setProperty('--fz', (2 + (i % 3)) + 'px');
      s.style.setProperty('--fo', (0.55 + (i % 4) * 0.13).toFixed(2));
      s.style.setProperty('--fy', fall + 'px');
      s.appendChild(document.createElement('i'));
      f.appendChild(s);
    }
    box.appendChild(f);
  }

  /* ---------- hero ---------- */
  function hero(root) {
    var track = root.querySelector('[data-spc-track]'), stage = root.querySelector('[data-spc-stage]');
    if (!track || !stage) return null;
    var L = {};
    [].forEach.call(root.querySelectorAll('[data-spc-l]'), function (e) { L[e.getAttribute('data-spc-l')] = e; });
    var deg = root.querySelector('[data-spc-deg]'), word = root.querySelector('[data-spc-word]'), line = root.querySelector('[data-spc-line]');
    var cw = { w: [], l: [] };
    try { cw = JSON.parse(root.querySelector('[data-spc-words]').textContent); } catch (e) {}
    var words = cw.w, lines = cw.l;
    var units = [].map.call(root.querySelectorAll('[data-spc-hunit]'), function (u) {
      return { box: u, fan: u.querySelector('.spc-forest-fan'), art: u.querySelector('.spc-forest-art'), sh: u.querySelector('.spc-forest-ush'), sl: [] };
    });
    var hg = document.getElementById('header-group');
    var built = false, last = -1, z = -1, d0 = -1, ticking = false, active = false, mw = 0, mh = 0, shift0 = -1;
    /* no real photo (owner rule: no AI frames): the drawing is the finished hero, so its window keeps its snow outside the pin too */
    function stillSnow() { if (!L.photo && L.snow && !L.snow.firstChild && !RM) flakes(L.snow, innerWidth >= 750 ? 22 : 16, 480); }

    function fits() { return !RM && innerHeight >= (innerWidth < 750 ? 600 : 640); }
    function pinned() { return track.classList.contains('is-pin'); }
    function build() {
      if (built) return; built = true;
      var big = innerWidth >= 750 ? 24 : 16, small = innerWidth >= 750 ? 12 : 10;
      units[0].sl = slices(units[0].fan, big);
      units[1].sl = slices(units[1].fan, small);
      units[2].sl = slices(units[2].fan, small);
      if (L.snow && !L.snow.firstChild) flakes(L.snow, innerWidth >= 750 ? 22 : 16, 480);
      if (L.matsnow && !L.matsnow.firstChild) flakes(L.matsnow, innerWidth >= 750 ? 22 : 14, innerWidth >= 750 ? 920 : 500);
    }
    function measure() {
      var w = innerWidth, h = innerHeight;
      if (mw === w && Math.abs(mh - h) < 120) return;
      mw = w; mh = h;
      track.style.setProperty('--ffvh', h + 'px');
    }
    function prog() {
      var travel = track.offsetHeight - innerHeight;
      if (travel <= 0) return 1;
      return clamp(-track.getBoundingClientRect().top / travel, 0, 1);
    }
    function O(e, v) { if (e) e.style.opacity = v.toFixed(3); }
    function fan(u, th) {
      for (var i = 0, n = u.sl.length; i < n; i++) {
        var a = -th * (n > 1 ? i / (n - 1) : 0), c = Math.abs(Math.cos(a * Math.PI / 180));
        u.sl[i].style.transform = 'rotateY(' + a.toFixed(2) + 'deg)';
        u.sl[i].style.opacity = (1 - 0.34 * (1 - c)).toFixed(3);
      }
      u.fan.style.transform = 'translateX(' + (-25 * Math.max(0, 1 - th / 180)).toFixed(2) + '%)';
    }
    function paint(p) {
      if (Math.abs(p - last) < 0.0004) return;
      last = p;
      var c = function (a, b) { return clamp((p - a) / (b - a), 0, 1); };
      var th = 360 * c(0.02, 0.66), th2 = 360 * c(0.70, 0.79), th3 = 360 * c(0.75, 0.84);
      fan(units[0], th); fan(units[1], th2); fan(units[2], th3);
      O(units[0].art, c(0.645, 0.7)); O(units[0].fan, 1 - c(0.69, 0.72));
      O(units[1].box, c(0.69, 0.72)); O(units[1].art, c(0.775, 0.805)); O(units[1].fan, 1 - c(0.80, 0.82));
      O(units[2].box, c(0.74, 0.77)); O(units[2].art, c(0.825, 0.855)); O(units[2].fan, 1 - c(0.85, 0.87));
      units[0].sh.style.transform = 'scaleX(' + (0.4 + 0.6 * th / 360).toFixed(3) + ')';
      O(L.dusk, c(0.08, 0.6)); O(L.glow, c(0.4, 0.72)); O(L.snow, c(0.68, 0.76));
      O(L.hint, 1 - c(0, 0.03)); O(L.photo, c(0.85, 0.93)); O(L.tint, 1 - c(0.93, 1));
      O(L.matsnow, c(0.9, 0.97)); O(L.cap, L.photo ? 1 - c(0.84, 0.89) : 1); O(L.shown, c(0.93, 0.99));
      var d = Math.round(th);
      if (deg && d !== d0) { d0 = d; deg.textContent = d + '°'; }
      var nz = th >= 359 ? 4 : th >= 250 ? 3 : th >= 110 ? 2 : th >= 1 ? 1 : 0;
      if (nz !== z) { z = nz; if (word) word.textContent = words[z]; if (line) line.textContent = lines[z]; }
    }
    /* the sticky header comes back over the page on any move up: slide the pinned stage down with it, never underneath it */
    function headerShift() {
      var r = track.getBoundingClientRect();
      var bottomGap = r.bottom - innerHeight;
      var nat = r.top > 0 ? r.top : (bottomGap < 0 ? bottomGap : 0);
      var hb = hg && !hg.classList.contains('sr-hdr-off') ? hg.offsetHeight : 0;
      var s = hb ? Math.max(0, nat >= 0 ? hb - nat : hb + nat) : 0;
      if (Math.abs(s - shift0) < 0.5) return;
      shift0 = s;
      stage.style.transform = s ? 'translate3d(0,' + s.toFixed(1) + 'px,0)' : '';
    }
    function barState() {
      var br = track.querySelector('.spc-forest-bar2');
      if (!br || getComputedStyle(br).display === 'none') { track.classList.remove('is-bar'); return; }
      var r = track.getBoundingClientRect();
      track.classList.toggle('is-bar', r.top < innerHeight && r.bottom > 0);
    }
    function frame() {
      ticking = false;
      if (pinned()) { paint(prog()); headerShift(); }
      barState();
    }
    function req() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    function setPin(on) {
      track.classList.toggle('is-pin', on);
      if (on) { build(); measure(); last = -1; paint(prog()); headerShift(); }
      else { shift0 = -1; stage.style.transform = ''; ['photo', 'shown', 'matsnow'].forEach(function (k) { if (L[k]) L[k].style.opacity = ''; }); if (L.matsnow && !L.matsnow.firstChild && !RM) flakes(L.matsnow, 14, 900); stillSnow(); }
    }
    function onResize() { var f = fits(); if (f !== pinned()) setPin(f); else if (f) { measure(); req(); } barState(); }

    /* drag across the picture simply moves the page; scroll stays the one source of truth */
    var zone = root.querySelector('[data-spc-zone]'), dg = null;
    var pd = function (e) { if (!pinned()) return; dg = { x: e.clientX, y: scrollY, on: false, id: e.pointerId }; };
    var pm = function (e) {
      if (!dg) return;
      var dx = e.clientX - dg.x;
      if (!dg.on) { if (Math.abs(dx) < 8) return; dg.on = true; zone.classList.add('is-grab'); try { zone.setPointerCapture(dg.id); } catch (_) {} }
      window.scrollTo({ top: dg.y + (-dx * 0.95) / 360 * 0.64 * (track.offsetHeight - innerHeight), behavior: 'instant' });
    };
    var pu = function () { dg = null; zone.classList.remove('is-grab'); };
    if (zone) { zone.addEventListener('pointerdown', pd); zone.addEventListener('pointermove', pm); zone.addEventListener('pointerup', pu); zone.addEventListener('pointercancel', pu); }

    var mo = null;
    if (hg && 'MutationObserver' in window) { mo = new MutationObserver(req); mo.observe(hg, { attributes: true, attributeFilter: ['class'] }); }
    var onScroll = function () { req(); };
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) {
        var on = es[0].isIntersecting;
        if (on === active) return;
        active = on;
        if (on) addEventListener('scroll', onScroll, { passive: true });
        else { removeEventListener('scroll', onScroll); req(); }
      }, { rootMargin: '240px 0px 240px 0px' });
      io.observe(track);
    } else addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onResize);

    if (fits() !== pinned()) setPin(fits());
    else if (pinned()) { build(); measure(); paint(prog()); }
    else { if (L.matsnow && !RM) flakes(L.matsnow, innerWidth >= 750 ? 22 : 14, innerWidth >= 750 ? 920 : 500); stillSnow(); }
    barState();

    return function () {
      removeEventListener('scroll', onScroll); removeEventListener('resize', onResize);
      if (io) io.disconnect(); if (mo) mo.disconnect();
    };
  }

  /* ---------- unwrap ---------- */
  function unwrap(root) {
    var un = root.querySelector('[data-spc-un]');
    var data = root.querySelector('[data-spc-steps]');
    if (!un || !data) return;
    var S; try { S = JSON.parse(data.textContent); } catch (e) { return; }
    var cap = un.querySelector('[data-spc-cap]'), sub = un.querySelector('[data-spc-sub]'), cta = un.querySelector('[data-spc-cta]');
    var nums = [].slice.call(un.querySelectorAll('[data-spc-stepno]')), segs = [].slice.call(un.querySelectorAll('[data-spc-seg]'));
    var again = un.querySelector('[data-spc-rewrap]'), buy = un.querySelector('[data-spc-unbuy]'), big = un.querySelector('.spc-forest-unbtn');
    var U = [].map.call(un.querySelectorAll('[data-spc-unit]'), function (u) {
      return { fan: u.querySelector('.spc-forest-fan'), art: u.querySelector('.spc-forest-art'), sl: [] };
    });
    var K = innerWidth >= 750 ? 12 : 10, built = false, step = 0;

    function build() { if (built) return; built = true; U.forEach(function (u) { u.sl = slices(u.fan, K); }); }
    function trees(open) {
      U.forEach(function (u, j) {
        u.sl.forEach(function (s, i) {
          var a = open ? -360 * i / (K - 1) : 0;
          var dl = RM ? 0 : (open ? 0.55 + j * 0.22 + i * 0.05 : j * 0.08 + (K - 1 - i) * 0.03);
          s.style.transition = RM ? 'none' : 'transform ' + (open ? '1.15s' : '0.7s') + ' cubic-bezier(.22,.8,.24,1) ' + dl.toFixed(2) + 's';
          s.style.transform = 'rotateY(' + a.toFixed(1) + 'deg)';
          s.style.opacity = open ? (1 - 0.34 * (1 - Math.abs(Math.cos(a * Math.PI / 180)))).toFixed(3) : '1';
        });
        var artDl = RM ? 0 : 0.55 + j * 0.22 + K * 0.05 + 0.75;
        u.fan.style.transitionDelay = open && !RM ? (0.55 + j * 0.22).toFixed(2) + 's' : '0s';
        u.fan.style.transform = open ? 'translateX(0%)' : 'translateX(-25%)';
        u.art.style.transitionDelay = open ? artDl.toFixed(2) + 's' : '0s';
        u.art.style.opacity = open ? '1' : '0';
        var fd = RM ? '0s' : (artDl + 0.45).toFixed(2) + 's';
        u.fan.style.opacity = open ? '0' : '1';
        u.fan.style.transition = RM ? 'none' : 'transform ' + (open ? '1s' : '.7s') + ' cubic-bezier(.22,.8,.24,1) ' + (open ? (0.55 + j * 0.22).toFixed(2) : '0') + 's, opacity .3s ease ' + (open ? fd : '0s');
      });
    }
    function show(n) {
      step = n;
      for (var i = 1; i <= 4; i++) un.classList.toggle('is-s' + i, n >= i);
      un.classList.toggle('is-open', n === 4);
      var s = S[n];
      if (cap) cap.textContent = s.cap;
      if (sub) sub.textContent = s.sub;
      if (cta) cta.textContent = s.cta;
      if (big) big.setAttribute('aria-label', s.cta);
      nums.forEach(function (e) { e.textContent = Math.min(n + 1, 4); });
      segs.forEach(function (b, k) { b.setAttribute('aria-pressed', n > k ? 'true' : 'false'); });
      if (again) again.hidden = n === 0;
      if (buy) buy.hidden = n < 4;
      if (n >= 3) {
        var first = !built;
        build();
        if (first) { requestAnimationFrame(function () { requestAnimationFrame(function () { trees(step === 4); }); }); } else trees(n === 4);
      }
    }
    var next = function () { show(step === 5 ? 4 : Math.min(step + 1, 5)); };
    [].forEach.call(un.querySelectorAll('[data-spc-next]'), function (b) { b.addEventListener('click', next); });
    segs.forEach(function (b) { b.addEventListener('click', function () { show(+b.getAttribute('data-spc-seg')); }); });
    if (again) again.addEventListener('click', function () { show(0); });
  }

  /* ---------- the tag and the gift note ---------- */
  function tag(root) {
    var w = root.querySelector('[data-spc-tag]');
    if (!w) return;
    var q = function (s) { return w.querySelector(s); };
    var to = q('[data-spc-in-to]'), from = q('[data-spc-in-from]'), note = q('[data-spc-in-note]');
    var out = q('[data-spc-note-out]'), left = q('[data-spc-left]'), cap = q('[data-spc-sccap]'), svg = q('[data-spc-sclabel]');
    var copy = q('[data-spc-copy]'), save = q('[data-spc-save]'), saved = q('[data-spc-saved]');
    var pills = [].slice.call(w.querySelectorAll('[data-spc-rec]'));
    var copyLabel = copy ? copy.textContent : '', savedHTML = saved ? saved.innerHTML : '';
    var LIM = 300;
    function names() {
      var n = (to.value || '').trim() || 'you';
      var short = n.length > 14 ? n.slice(0, 13) + '…' : n;
      [].forEach.call(root.querySelectorAll('[data-spc-to]'), function (e) { e.textContent = short; });
      [].forEach.call(root.querySelectorAll('[data-spc-from]'), function (e) { e.textContent = (from.value || '').trim() || 'me'; });
    }
    function words() {
      if (out) out.textContent = (note.value || '').trim() || '…';
      if (left) left.textContent = LIM - note.value.length;
      if (copy) copy.textContent = copyLabel;
      if (saved) saved.hidden = true;
    }
    [to, from].forEach(function (i) { i.addEventListener('input', function () { names(); words(); }); });
    note.addEventListener('input', words);
    pills.forEach(function (b) {
      b.addEventListener('click', function () {
        var k = +b.getAttribute('data-spc-rec');
        pills.forEach(function (p) { p.setAttribute('aria-pressed', p === b ? 'true' : 'false'); });
        w.classList.remove('is-rec0', 'is-rec1', 'is-rec2'); w.classList.add('is-rec' + k);
        if (cap) cap.textContent = b.getAttribute('data-cap');
        if (svg) svg.setAttribute('aria-label', b.getAttribute('data-alt'));
        note.value = b.getAttribute('data-note');
        words();
      });
    });
    function text() { return 'To ' + ((to.value || '').trim() || 'you') + ',\n' + note.value + '\n— ' + ((from.value || '').trim() || 'me'); }
    if (copy) copy.addEventListener('click', function () {
      try { if (navigator.clipboard) navigator.clipboard.writeText(text()).catch(function () {}); } catch (e) {}
      copy.textContent = copy.getAttribute('data-done');
    });
    /* the same cart attributes the bag's "This is a gift" saves (sections/sp2-cart); the recipient's email stays in the bag */
    if (save) save.addEventListener('click', function () {
      var who = (from.value || '').trim();
      var msg = (note.value || '').trim();
      if (who) msg = (msg + '\n— ' + who).slice(0, LIM);
      save.disabled = true;
      fetch(root_url + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { Gift: 'Yes', gift_to_name: (to.value || '').trim().slice(0, 80), gift_note: msg } })
      }).then(function (r) { if (!r.ok) throw new Error('save'); return r.json(); }).then(function () {
        saved.innerHTML = savedHTML; saved.hidden = false;
        document.dispatchEvent(new Event('cart:updated'));
      }).catch(function () {
        saved.textContent = save.getAttribute('data-err'); saved.hidden = false;
      }).then(function () { save.disabled = false; });
    });
    words();
  }

  /* ---------- lamp in the night band, phone bar ---------- */
  function lower(root) {
    var off = [];
    var night = root.querySelector('[data-spc-night]'), lit = root.querySelector('[data-spc-nightlit]');
    if (night && lit && !RM && 'IntersectionObserver' in window) {
      var t = false;
      var up = function () { t = false; var r = night.getBoundingClientRect(), h = innerHeight; lit.style.opacity = clamp((h * 0.86 - r.top) / (h * 0.6), 0, 1).toFixed(3); };
      var on = function () { if (!t) { t = true; requestAnimationFrame(up); } };
      var nio = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { addEventListener('scroll', on, { passive: true }); on(); } else removeEventListener('scroll', on); });
      nio.observe(night);
      off.push(function () { nio.disconnect(); removeEventListener('scroll', on); });
      lit.style.opacity = '0';
    }
    var bar = root.querySelector('[data-spc-bar]'), track = root.querySelector('[data-spc-track]');
    if (bar && track) {
      var sb = bar.querySelector('button'), ft = null, vis = null, tick = false;
      var upd = function () {
        tick = false;
        ft = ft || document.querySelector('.spf, #shopify-section-group-footer-group, footer');
        var o = track.getBoundingClientRect().bottom < 0 && !(ft && ft.getBoundingClientRect().top < innerHeight);
        if (o === vis) return;
        vis = o; bar.classList.toggle('is-on', o); bar.setAttribute('aria-hidden', o ? 'false' : 'true'); sb.tabIndex = o ? 0 : -1;
      };
      var sc = function () { if (!tick) { tick = true; requestAnimationFrame(upd); } };
      addEventListener('scroll', sc, { passive: true });
      off.push(function () { removeEventListener('scroll', sc); });
      upd();
    }
    return function () { off.forEach(function (f) { f(); }); };
  }

  function init(root) {
    if (!root || root.dataset.spcOn) return;
    root.dataset.spcOn = '1';
    var a = hero(root);
    unwrap(root);
    tag(root);
    var b = lower(root);
    root.__spcOff = function () { if (a) a(); if (b) b(); };
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-spc-forest]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target && e.target.querySelector && e.target.querySelector('[data-spc-forest]');
    if (r && r.__spcOff) r.__spcOff();
  });
})();
